import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AuthService } from '@scandium-oy/ngx-scandium';
import { AppCommonModule } from '../common.module';
import { ModalShellComponent } from '../ui/modal-shell/modal-shell.component';

@Component({
  selector: 'app-pending-site-activation-dialog',
  templateUrl: './pending-site-activation.dialog.html',
  styleUrls: ['./pending-site-activation.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AppCommonModule, ModalShellComponent],
})
export class PendingSiteActivationDialogComponent {
  private readonly authService = inject(AuthService);
  private readonly modalController = inject(ModalController);

  readonly loggingOut = signal(false);

  async logout() {
    if (this.loggingOut()) {
      return;
    }
    this.loggingOut.set(true);
    try {
      await this.authService.signOut();
      await this.modalController.dismiss(null, 'logout');
    } finally {
      this.loggingOut.set(false);
    }
  }
}
